(function () {
  var root = document.querySelector(".tr20-layers");
  if (!root) return;

  var track = root.querySelector(".tr20-layers__track");
  var layers = [0, 1, 2].map(function (index) {
    return root.querySelector('.tr20-layers__layer[data-layer="' + index + '"]');
  });
  var videos = layers.map(function (layer) {
    return layer ? layer.querySelector(".tr20-layers__video") : null;
  });
  var navButtons = Array.prototype.slice.call(root.querySelectorAll("[data-layer-nav]"));
  var hitTargets = Array.prototype.slice.call(root.querySelectorAll("[data-layer-hit]"));
  var copyBeats = Array.prototype.slice.call(root.querySelectorAll(".tr20-layers__copy-beat"));
  var forceReducedMotion =
    /^(?:127\.0\.0\.1|localhost)$/.test(location.hostname) &&
    /(?:\?|&)tr20-reduced-motion=1(?:&|$)/.test(location.search);
  var reducedMotion =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches || forceReducedMotion;
  root.classList.toggle("is-reduced-motion", reducedMotion);

  var FOCUS_ZONES = [
    [0.12, 0.42],
    [0.42, 0.62],
    [0.62, 0.82],
  ];
  var FOCUS_ORDER = [0, 2, 1];
  var playTimer = [0, 0, 0];
  var state = {
    active: -2,
    exploded: false,
    explode: 0,
    hover: -1,
    clicking: false,
  };
  var raf = 0;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function ease(value) {
    var t = clamp(value, 0, 1);
    return t * t * (3 - 2 * t);
  }

  function range(value, start, end) {
    return clamp((value - start) / Math.max(end - start, 0.0001), 0, 1);
  }

  function mix(a, b, t) {
    return a + (b - a) * clamp(t, 0, 1);
  }

  function stickyProgress() {
    if (!track) return 0;
    var vh = Math.max(window.innerHeight || 1, 1);
    var rect = track.getBoundingClientRect();
    var maxTravel = Math.max(track.offsetHeight - vh, 1);
    return clamp(-rect.top / maxTravel, 0, 1);
  }

  function isPinned() {
    if (!track) return false;
    var nav = document.getElementById("nav-fixed-top");
    var navH = nav ? nav.offsetHeight : 0;
    return track.getBoundingClientRect().top <= navH + 2;
  }

  function activeFromProgress(p) {
    if (!isPinned()) return -1;
    for (var position = 0; position < FOCUS_ZONES.length; position += 1) {
      if (p >= FOCUS_ZONES[position][0] && p < FOCUS_ZONES[position][1]) {
        return FOCUS_ORDER[position];
      }
    }
    if (p >= FOCUS_ZONES[FOCUS_ZONES.length - 1][1]) return FOCUS_ORDER[FOCUS_ORDER.length - 1];
    return -1;
  }

  function progressForPart(index) {
    var position = FOCUS_ORDER.indexOf(index);
    var start = FOCUS_ZONES[position][0];
    var end = FOCUS_ZONES[position][1];
    return mix(start, end, 0.28);
  }

  function explodeFromProgress(p) {
    return p >= FOCUS_ZONES[0][0] ? 1 : 0;
  }

  function stopJobs(index) {
    if (playTimer[index]) clearTimeout(playTimer[index]);
    playTimer[index] = 0;
    if (videos[index]) videos[index].pause();
    if (layers[index]) layers[index].classList.remove("is-resetting");
  }

  function resetVideo(index) {
    var video = videos[index];
    var layer = layers[index];
    if (!video || !layer) return;
    stopJobs(index);
    video.pause();
    if ((video.currentTime || 0) < 0.04) {
      try {
        video.currentTime = 0;
      } catch (err) {}
      return;
    }
    layer.classList.add("is-resetting");
    playTimer[index] = setTimeout(function () {
      playTimer[index] = 0;
      var revealed = false;
      function reveal() {
        if (revealed) return;
        revealed = true;
        layer.classList.remove("is-resetting");
      }
      video.addEventListener("seeked", reveal, { once: true });
      try {
        video.currentTime = 0;
      } catch (err) {
        reveal();
      }
      setTimeout(reveal, 180);
    }, 260);
  }

  function playVideo(index) {
    var video = videos[index];
    if (!video) return;
    ensureLayerSrc(video);
    stopJobs(index);
    try {
      video.currentTime = 0;
    } catch (err) {}
    playTimer[index] = setTimeout(function () {
      playTimer[index] = 0;
      var play = video.play();
      if (play && play.then) {
        play.then(function () {
          if (window.TR20Debug) window.TR20Debug.set("parts." + index + ".play", "ok");
        }).catch(function (error) {
          if (window.TR20Debug) window.TR20Debug.set("parts." + index + ".play", "FAIL " + (error && error.name ? error.name : error));
        });
      }
    }, 90);
  }

  function updateCopy(active) {
    copyBeats.forEach(function (beat) {
      var index = parseInt(beat.getAttribute("data-layer") || "-1", 10);
      var on = index === active;
      beat.classList.toggle("is-active", on);
      beat.setAttribute("aria-hidden", on ? "false" : "true");
    });
    navButtons.forEach(function (button) {
      var index = parseInt(button.getAttribute("data-layer-nav") || "-1", 10);
      var on = index === active;
      button.classList.toggle("is-active", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function isMobile() {
    return window.matchMedia("(max-width: 980px)").matches;
  }

  function applyClasses(active, explode) {
    var exploded = explode > 0.02;
    var mobile = isMobile();
    root.style.setProperty("--explode", String(explode));
    root.style.setProperty("--ui", String(ease(range(explode, 0.45, 0.9))));
    root.classList.toggle("is-exploded", exploded);
    root.classList.toggle("has-focus", active >= 0);
    root.classList.toggle("is-cuff", active === 0);
    root.classList.toggle("is-shell", active === 1);
    root.classList.toggle("is-liner", active === 2);
    layers.forEach(function (layer, index) {
      if (!layer) return;
      var restX = 0;
      var restY = index === 0 ? -17 : index === 1 ? 17 : 0;
      var restZ = index === 0 ? 100 : index === 1 ? 0 : -130;
      var restScale = index === 0 ? 1 : index === 1 ? 0.94 : 0.8;
      var focusX = mobile ? 0 : index === 0 ? -12 : index === 1 ? -9 : -11;
      var focusY = 0;
      var focusScale = mobile ? 1.02 : index === 2 ? 0.92 : index === 1 ? 1.03 : 1.06;
      var dimX = mobile ? 0 : -7;
      var dimY = 0;
      if (active === 0) dimY = index === 2 ? 15 : 30;
      if (active === 2) dimY = index === 0 ? -28 : 28;
      if (active === 1) dimY = index === 0 ? -30 : -15;
      if (mobile) {
        restY = index === 0 ? -10 : index === 1 ? 10 : 0;
        if (active === 0) dimY = index === 2 ? 8 : 14;
        if (active === 2) dimY = index === 0 ? -14 : 14;
        if (active === 1) dimY = index === 0 ? -14 : -8;
      }
      layer.style.setProperty("--rest-y", restY + "vh");
      layer.style.setProperty("--dim-x", dimX + "%");
      layer.style.setProperty("--dim-y", dimY + "vh");
      layer.style.setProperty("--focus-x", focusX + "%");
      layer.style.setProperty("--focus-y", focusY + "vh");
      layer.style.setProperty("--focus-s", String(focusScale));
      layer.style.setProperty("--layer-x", restX * explode + "%");
      layer.style.setProperty("--layer-y", restY * explode + "vh");
      layer.style.setProperty("--layer-z", restZ * explode + "px");
      layer.style.setProperty("--layer-s", String(mix(1, restScale, explode)));
      layer.classList.toggle("is-active", active === index);
      layer.classList.toggle("is-dimmed", active >= 0 && active !== index);
      layer.classList.toggle("is-hover", state.hover === index && active !== index);
    });
    hitTargets.forEach(function (target) {
      var index = parseInt(target.getAttribute("data-layer-hit") || "-1", 10);
      var restX = 0;
      var restY = index === 0 ? (mobile ? -10 : -17) : index === 1 ? (mobile ? 10 : 17) : 0;
      var dimX = mobile ? 0 : -7;
      var dimY = 0;
      if (active === 0) dimY = index === 2 ? (mobile ? 8 : 15) : (mobile ? 14 : 30);
      if (active === 2) dimY = index === 0 ? (mobile ? -14 : -28) : (mobile ? 14 : 28);
      if (active === 1) dimY = index === 0 ? (mobile ? -14 : -30) : (mobile ? -8 : -15);
      var focused = active >= 0;
      target.style.setProperty("--hit-x", (focused ? dimX : restX * explode) + "%");
      target.style.setProperty("--hit-y", (focused ? dimY : restY * explode) + "vh");
      target.classList.toggle("is-available", explode > 0.8 && active !== index);
    });
  }

  var restackTimer = 0;
  var foldClearTimer = 0;

  function clearRestack() {
    if (restackTimer) {
      clearTimeout(restackTimer);
      restackTimer = 0;
    }
    if (foldClearTimer) {
      clearTimeout(foldClearTimer);
      foldClearTimer = 0;
    }
    root.classList.remove("is-restacking");
  }

  function requestActive(next, explode) {
    var exploded = explode > 0.02;
    state.exploded = exploded;
    state.explode = explode;

    if (next === state.active) {
      if (root.classList.contains("is-restacking")) return;
      applyClasses(state.active, explode);
      return;
    }

    var leaving = state.active;
    var unfolding = leaving < 0 && next >= 0;
    var folding = leaving >= 0 && next < 0 && !exploded;

    if (unfolding) clearRestack();

    if (folding && !reducedMotion) {
      if (root.classList.contains("is-restacking")) return;
      root.classList.add("is-folding", "is-restacking");
      root.classList.remove("is-unfolding");
      applyClasses(leaving, 1);
      restackTimer = setTimeout(function () {
        restackTimer = 0;
        state.active = next;
        updateCopy(next);
        if (leaving >= 0) resetVideo(leaving);
        videos.forEach(function (video, index) {
          if (!video || index === next || index === leaving) return;
          if (video.currentTime > 0.04) resetVideo(index);
        });
        applyClasses(next, explode);
        root.classList.remove("is-restacking");
        foldClearTimer = setTimeout(function () {
          foldClearTimer = 0;
          root.classList.remove("is-folding");
        }, 1100);
      }, 560);
      return;
    }

    root.classList.toggle("is-unfolding", unfolding);
    root.classList.toggle("is-folding", folding);
    state.active = next;
    updateCopy(next);
    if (leaving >= 0) resetVideo(leaving);
    videos.forEach(function (video, index) {
      if (!video || index === next || index === leaving) return;
      if (video.currentTime > 0.04) resetVideo(index);
    });
    if (next >= 0) playVideo(next);
    applyClasses(next, explode);
  }

  function readState() {
    var p = stickyProgress();
    var explode = explodeFromProgress(p);
    var active = activeFromProgress(p);
    requestActive(active, explode);
  }

  function tick() {
    raf = 0;
    var nav = document.getElementById("nav-fixed-top");
    root.style.setProperty("--nav-offset", (nav ? nav.offsetHeight : 0) + "px");
    if (!state.clicking) readState();
  }

  function requestTick() {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  }

  function scrollToProgress(target) {
    var vh = Math.max(window.innerHeight || 1, 1);
    var maxTravel = Math.max(track.offsetHeight - vh, 1);
    var top = window.scrollY + track.getBoundingClientRect().top + target * maxTravel;
    window.scrollTo({ top: top, behavior: reducedMotion ? "auto" : "smooth" });
  }

  function goTo(index) {
    if (isMobile()) {
      state.clicking = false;
      scrollToProgress(progressForPart(index));
      return;
    }
    state.clicking = true;
    requestActive(index, 1);
    scrollToProgress(progressForPart(index));
    setTimeout(function () {
      state.clicking = false;
      readState();
    }, 1600);
  }

  var wantShow = false;

  function stackReady() {
    return videos.every(function (video) {
      return video && video.readyState >= 2;
    });
  }

  function revealStack() {
    if (!wantShow || root.classList.contains("is-stack-ready")) return;
    if (!stackReady()) return;
    root.classList.add("is-stack-ready");
  }

  function ensureLayerSrc(video) {
    if (!video) return;
    if (window.TR20VideoCompat && window.TR20VideoCompat.activate) {
      window.TR20VideoCompat.activate(video);
    }
    if (!video.getAttribute("data-stack-bound")) {
      video.setAttribute("data-stack-bound", "1");
      video.addEventListener("loadeddata", revealStack);
    }
    if (!video.getAttribute("src")) {
      var src = video.getAttribute("data-src") || "";
      if (!src) return;
      video.src = src;
    }
    if (video.readyState < 2) {
      try {
        video.load();
      } catch (err) {}
    }
    revealStack();
  }

  function prepareVideos() {
    videos.forEach(function (video) {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.loop = false;
      video.preload = "none";
      video.pause();
      video.addEventListener("loadedmetadata", function () {
        try {
          video.currentTime = 0;
        } catch (err) {}
      });
      video.addEventListener("ended", function () {
        video.pause();
      });
    });
    if (!root || !("IntersectionObserver" in window)) {
      wantShow = true;
      videos.forEach(ensureLayerSrc);
      return;
    }
    function startLayerLoads() {
      if (window.TR20Debug) window.TR20Debug.set("parts.load", "started near viewport");
      videos.forEach(ensureLayerSrc);
    }
    var loadIo = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        startLayerLoads();
        loadIo.disconnect();
      },
      { rootMargin: "180% 0px" }
    );
    loadIo.observe(root);
    var showIo = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        wantShow = true;
        videos.forEach(ensureLayerSrc);
        revealStack();
        window.setTimeout(function () {
          if (!root.classList.contains("is-stack-ready") && videos.some(function (video) {
            return video && video.readyState >= 2;
          })) {
            root.classList.add("is-stack-ready");
          }
        }, 1200);
        showIo.disconnect();
      },
      { threshold: 0.08 }
    );
    showIo.observe(root.querySelector(".tr20-layers__sticky") || root);
  }

  navButtons.forEach(function (button) {
    var index = parseInt(button.getAttribute("data-layer-nav") || "-1", 10);
    button.addEventListener("mouseenter", function () {
      state.hover = index;
      applyClasses(state.active, state.explode);
    });
    button.addEventListener("mouseleave", function () {
      if (state.hover === index) state.hover = -1;
      applyClasses(state.active, state.explode);
    });
    button.addEventListener("click", function () {
      goTo(index);
    });
  });

  hitTargets.forEach(function (target) {
    var index = parseInt(target.getAttribute("data-layer-hit") || "-1", 10);
    target.addEventListener("mouseenter", function () {
      state.hover = index;
      applyClasses(state.active, state.explode);
    });
    target.addEventListener("mouseleave", function () {
      if (state.hover === index) state.hover = -1;
      applyClasses(state.active, state.explode);
    });
    target.addEventListener("focus", function () {
      state.hover = index;
      applyClasses(state.active, state.explode);
    });
    target.addEventListener("blur", function () {
      if (state.hover === index) state.hover = -1;
      applyClasses(state.active, state.explode);
    });
    target.addEventListener("click", function () {
      goTo(index);
    });
  });

  window.addEventListener("scroll", requestTick, { passive: true });
  window.addEventListener("resize", requestTick);
  prepareVideos();

  requestTick();
})();
